import { render, staticRenderFns } from "./bulma_subtab.vue?vue&type=template&id=55842735&scoped=true&lang=html"
import script from "./bulma_subtab.vue?vue&type=script&lang=js"
export * from "./bulma_subtab.vue?vue&type=script&lang=js"
import style0 from "./bulma_subtab.vue?vue&type=style&index=0&id=55842735&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55842735",
  null
  
)

export default component.exports